import type { MarketGroupsApi } from "@/v2/api/metadata/market-groups";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { marketGroupGamesStatusOptions, marketGroupPositionValidator } from "../../../../shared";
import { marketGroupId, notifySuccess } from "../shared";

const prematchTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "prematchGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: marketGroupGamesStatusOptions,
        inheritance: { computedKey: "computedStatus", parentKey: "parentStatus" },
      },
      {
        type: "text-field",
        name: "position",
        label: "Position",
        placeholder: "Enter position",
        inputType: "number",
        validate: marketGroupPositionValidator,
        inheritance: { computedKey: "computedPosition", parentKey: "parentPosition" },
      },
    ],
  },
];

export function createPrematchTab(marketGroupsApi: MarketGroupsApi): ContentTab {
  return {
    id: "prematch",
    label: "Prematch",
    save: createInheritableTabSave({
      children: prematchTabChildren,
      persist: async (patch, ctx: DialogTabSaveContext) => {
        await marketGroupsApi.update(marketGroupId(ctx.values), patch);
        notifySuccess();
      },
    }),
    children: prematchTabChildren,
  };
}
